import { useEffect, useState } from 'react'
import { Box, Button, Container, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import { listQuizzes, deleteQuiz } from '../services/Common/quiz.service'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'

export default function QuizListPage() {
  const [quizzes, setQuizzes] = useState([])
  const navigate = useNavigate()

  const load = async () => {
    try {
      const data = await listQuizzes()
      setQuizzes(data)
    } catch (e) { console.error(e); toast.error('Failed to load quizzes') }
  }

  useEffect(() => { load() }, [])

  const onDelete = async (id) => {
    if (!window.confirm('Delete quiz?')) return
    try { await deleteQuiz(id); toast.success('Deleted'); load() } catch (e) { console.error(e); toast.error('Delete failed') }
  }

  return (
    <Container>
      <Box display='flex' justifyContent='space-between' alignItems='center' my={2}>
        <Typography variant='h4'>Quizzes</Typography>
        <Button variant='contained' onClick={() => navigate('/quiz/create')}>Create Quiz</Button>
      </Box>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Question</TableCell>
              <TableCell>Choices</TableCell>
              <TableCell>Correct</TableCell>
              <TableCell>Question For</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {quizzes.map(q => (
              <TableRow key={q._id}>
                <TableCell>{q.question}</TableCell>
                <TableCell>{(q.choices || []).map(c => c.text).join(' | ')}</TableCell>
                <TableCell>{(q.choices && q.choices[q.correctIndex]) ? q.choices[q.correctIndex].text : ''}</TableCell>
                <TableCell>{q.targetRole === 'general' ? 'All Players' : q.targetRole}</TableCell>
                <TableCell>
                  <Button size='small' onClick={() => navigate(`/quiz/${q._id}`)}>Edit</Button>
                  <Button size='small' onClick={() => navigate(`/quiz/${q._id}/stats`)}>Stats</Button>
                  <Button size='small' color='error' onClick={() => onDelete(q._id)}>Delete</Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Container>
  )
}
